import { team_members } from "../../constants/team";
require("./../../partials/supporters.js");

const members_html = team_members
    .map((member) => {
        const social_items = member.socials
            .map(
                (social) => `
        <a href="${social.url}">
            <i class="icon ${social.icon}"></i>
        </a>
    `
            )
            .join("");

        return `
        <div class="member">
            <div class="details">
                <div class="image" style="background-image: url('${member.image}')"></div>
                <div>
                    <p class="name">${member.name}</p>
                    <p class="position">${member.position}</p>
                </div>
            </div>
            <div class="about">${member.about}</div>
            <div class="social">
                <span>شبکه های اجتماعی</span>
                <div>
                    ${social_items}
                </div>
            </div>
        </div>
    `;
    })
    .join("");

document.getElementById("team_members").innerHTML = members_html;
